import { useMutation, useQueryClient } from '@tanstack/react-query';

import API from 'configs/API';
import { axiosDelete } from 'utils/apis/axios';

const deleteCollection = async (id) => {
  const { data } = await axiosDelete(false, API.ARTWORK.DELETE_COLLECTION(id));

  return data;
};

const useDeleteCollection = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteCollection,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [API.ARTWORK.LIST_GALLERY_COLLECTION] });
    },
  });
};

export default useDeleteCollection;
